var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro"},[_c('i',{staticClass:"closeIcon icon icon-cross icon-3x",on:{"click":function($event){return _vm.hideIntro()}}}),_c('div',{attrs:{"id":"introText"}})])}
var staticRenderFns = []

export { render, staticRenderFns }